(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-section"] && !Shopify.designMode) return;
  try {
    
  const prefillProductInquiry = () => {
    const field = document.getElementById('contact-product');
    if (!field || field.value.trim()) return;
    const params = new URLSearchParams(window.location.search);
    const clean = value => Array.from(value || '').filter(char => char.charCodeAt(0) >= 32 && char.charCodeAt(0) !== 127).join('').trim().slice(0, 180);
    const product = clean(params.get('product'));
    const sku = clean(params.get('sku'));
    field.value = (sku && product.includes(sku) ? product : [sku, product].filter(Boolean).join(' — ')).slice(0, 240);
  };
  const showContactSuccessDialog = () => {
    document.querySelectorAll('[data-contact-success-dialog]').forEach(dialog => {
      if (dialog.dataset.modalReady === 'true') return;
      dialog.dataset.modalReady = 'true';
      const closeButton = dialog.querySelector('[data-contact-success-close]');
      closeButton?.addEventListener('click', () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      });
      if (typeof dialog.showModal === 'function') {
        try {
          dialog.close();
          dialog.showModal();
        } catch {
          dialog.setAttribute('open', '');
        }
      }
    });
  };
  const initializeContactSection = () => {
    prefillProductInquiry();
    showContactSuccessDialog();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeContactSection, { once: true });
  } else {
    initializeContactSection();
  }
  document.addEventListener('shopify:section:load', initializeContactSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-dawn"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    const normalizeQuoteSearch = () => {
      if (!document.querySelector('.yc-search')) return;
      const url = new URL(window.location.href);
      let changed = false;
      for (const key of ['filter.v.price.gte', 'filter.v.price.lte', 'filter.v.availability']) {
        if (url.searchParams.has(key)) {
          url.searchParams.delete(key);
          changed = true;
        }
      }
      if (url.searchParams.getAll('sort_by').some((value) =>
        value === 'price-ascending' || value === 'price-descending'
      )) {
        url.searchParams.delete('sort_by');
        changed = true;
      }
      if (!changed) return;
      url.searchParams.delete('page');
      window.location.replace(url.toString());
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', normalizeQuoteSearch, { once: true });
    } else {
      normalizeQuoteSearch();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yc-product-catalog')) {
    customElements.define('yc-product-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const tabs = Array.from(this.querySelectorAll('[data-catalog-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-catalog-panel]'));
        const select = (id) => {
          if (!panels.some(panel => panel.dataset.catalogPanel === id)) return;
          tabs.forEach(tab => tab.setAttribute('aria-current', String(tab.dataset.catalogTab === id)));
          panels.forEach(panel => { panel.hidden = panel.dataset.catalogPanel !== id; });
        };
        this.handleHash = () => {
          const id = location.hash.replace('#catalog-', '');
          select(panels.some(panel => panel.dataset.catalogPanel === id) ? id : tabs[0]?.dataset.catalogTab);
        };
        tabs.forEach(tab => tab.addEventListener('click', event => {
          event.preventDefault();
          const activeTab = tabs.find(item => item.getAttribute('aria-current') === 'true');
          const url = new URL(location.href);
          const pageParams = Array.from(url.searchParams.keys()).filter(key => key === 'page' || key.startsWith('page_'));
          if (activeTab?.dataset.catalogTab !== tab.dataset.catalogTab && pageParams.length) {
            pageParams.forEach(key => url.searchParams.delete(key));
            url.hash = tab.getAttribute('href');
            location.assign(url.toString());
            return;
          }
          history.replaceState(null, '', tab.getAttribute('href'));
          select(tab.dataset.catalogTab);
        }));
        window.addEventListener('hashchange', this.handleHash);
        this.handleHash();
      }
      disconnectedCallback() { window.removeEventListener('hashchange', this.handleHash); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
